import React, { useEffect, useState, useContext, useRef } from "react";
// import { useLocation } from 'react-router-dom'
import styles from "./GeneResult.module.css";
import moment from "moment";
import "moment/locale/th";
// import classify from '../../service/classify.json'
import { HashLoader } from "react-spinners";
import Button from "../../component/material/button/Button";
// import Select from '../../component/material/select/Select'
import NotfoundUi from "../../component/notfound/NotfoundUi";
import * as microserviceApi from "../../service/microserviceApi";

import { CurrentUserContext } from "../../App";

function GeneResultMicroservice() {
  const { setIsMessage } = useContext(CurrentUserContext);

  const [loading, setLoading] = useState(false);
  const [toggle, setToggle] = useState("gene"); // gene, health, note
  // const [geneType, setGeneType] = useState('allergy') // allergy, degrading
  const resultName = useRef("");
  const [labList, setLabList] = useState([]);

  const [labListAllergy, setLabListAllergy] = useState([]);
  const [labListDegrading, setLabListDegrading] = useState([]);

  const [name, setName] = useState("");
  const [pid, setPid] = useState("");
  const [age, setAge] = useState("");
  const [birthday, setBirthday] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");

  const [platform, setPlatform] = useState("");
  const [token, setToken] = useState("");

  // const geneTypeList = [
  //   {
  //     key: 'allergy',
  //     value: 'ยีนแพ้ยา'
  //   },
  //   {
  //     key: 'degrading',
  //     value: 'ยีนย่อยสลายยา'
  //   }
  // ]
  // const [resultNameList, setResultNameList] = useState([])
  const [patient, setPatient] = useState(null);

  const [checkLabAllergy, setCheckLabAllergy] = useState(false);
  const [checkLabDegrading, setCheckLabDegrading] = useState(false);

  useEffect(() => {
    const uselessData = () => {
      return {
        name: name,
        pid: pid,
        age: age,
        birthday: birthday,
        phoneNumber: phoneNumber,
        email: email,
      };
    };
    uselessData();
    // setCredentialToken(location.state['credential_token'])
    const getParameter = () => {
      let url = decodeURIComponent(window.location.href);
      let newURL = new URL(url);
      let data = newURL.searchParams;

      if (!data.get("token")) {
        setIsMessage({ type: "warning", data: "token is require" });
        return;
      }
      if (!data.get("platform")) {
        setIsMessage({ type: "warning", data: "platform is require" });
        return;
      }

      let token = data.get("token").split(" ").join("+");
      let platform = data.get("platform");
      setToken(token);
      setPlatform(platform);
    };
    getParameter();
  }, [setIsMessage, name, pid, age, birthday, phoneNumber, email]);

  // useEffect(() => {
  //   if (geneType === 'allergy') {
  //     getDrugAllergyGene()
  //     setResultNameList([
  //       { "key": "", "value": "ทั้งหมด" },
  //       { "key": "HLA-B*58:01", "value": "HLA-B*58:01" },
  //       { "key": "HLA-B*57:01", "value": "HLA-B*57:01" },
  //       { "key": "HLA-B*15:02", "value": "HLA-B*15:02" },
  //     ])
  //   } else if (geneType === 'degrading') {
  //     getDrugDegradingGene()
  //     setResultNameList([
  //       { "key": "", "value": "ทั้งหมด" },
  //       { "key": "NAT2-diplotype", "value": "NAT2-diplotype" }
  //     ])
  //   }
  //   setResultName('')
  // }, [geneType, token, platform])

  useEffect(() => {
    if (checkLabAllergy && checkLabDegrading) {
      let resultList = [];

      resultList.push(...labListAllergy);
      resultList.push(...labListDegrading);

      setLabList(resultList);
    }
  }, [checkLabAllergy, checkLabDegrading, labListAllergy, labListDegrading]);

  useEffect(() => {
    const getDrugDegradingGene = async () => {
      if (!token || !platform) {
        return;
      }
      setLoading(true);
      let res = await microserviceApi.getDrugDegradingGene(token, platform);
      setLoading(false);

      if (res) {
        if (res["data"]["code"] === 200) {
          let labList = res["data"]["lab_list"];

          // for (let ilab = 0; ilab < labList.length; ilab += 1) {
          //   let lab = labList[ilab]
          //   lab['patient_recommend'] = []
          //   for (let iclass = 0; iclass < classify.length; iclass += 1) {
          //     let classifyItem = classify[iclass]

          //     let labName = lab['lab_classify']['testing_name'].toLowerCase().replace('-', '').replace('_', '').replace(' ', '')
          //     let labResult = lab['lab_classify']['testing_result_type'].toLowerCase().replace('-', '').replace('_', '').replace(' ', '')

          //     let className = classifyItem['testing_name'].toLowerCase().replace('-', '').replace('_', '').replace(' ', '')
          //     let classResult = classifyItem['result'].toLowerCase().replace('-', '').replace('_', '').replace(' ', '')

          //     if (labName === className && labResult === classResult) {
          //       lab['patient_recommend'] = classifyItem['patient_recommend']
          //     }
          //   }
          // }

          setLabListDegrading(labList);
          setCheckLabDegrading(true);
          setPatient(res["data"]["patient"]);
        } else {
          setIsMessage({
            type: "warning",
            data: res["data"]["message_th"] || res["data"]["message"],
          });
        }
      } else {
        setIsMessage({
          type: "error",
          data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
        });
      }
    };

    const getDrugAllergyGene = async () => {
      if (!token || !platform) {
        return;
      }
      setLoading(true);
      let res = await microserviceApi.getDrugAllergyGene(token, platform);
      setLoading(false);

      if (res) {
        if (res["data"]["code"] === 200) {
          let labList = res["data"]["lab_list"];

          // for (let ilab = 0; ilab < labList.length; ilab += 1) {
          //   let lab = labList[ilab]
          //   lab['patient_recommend'] = []
          //   for (let iclass = 0; iclass < classify.length; iclass += 1) {
          //     let classifyItem = classify[iclass]

          //     let labName = lab.lab_classify?.testing_name?.toLowerCase().replace('-', '').replace('_', '').replace(' ', '')
          //     let labResult = lab.lab_classify?.testing_result_type?.toLowerCase().replace('-', '').replace('_', '').replace(' ', '')

          //     let className = classifyItem.testing_name?.toLowerCase().replace('-', '').replace('_', '').replace(' ', '')
          //     let classResult = classifyItem.result?.toLowerCase().replace('-', '').replace('_', '').replace(' ', '')

          //     if (labName && labResult && className && classResult && labName === className && labResult === classResult) {
          //       lab['patient_recommend'] = classifyItem['patient_recommend']
          //     }
          //   }
          // }

          setLabListAllergy(labList);
          setCheckLabAllergy(true);
          // console.log(labListAllergy)
          setPatient(res["data"]["patient"]);
        } else {
          setIsMessage({
            type: "warning",
            data: res["data"]["message_th"] || res["data"]["message"],
          });
        }
      } else {
        setIsMessage({
          type: "error",
          data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
        });
      }
    };
    const fetchData = async () => {
      // console.log("fetch data");
      await getDrugAllergyGene();
      await getDrugDegradingGene();
    };
    if (token && platform) {
      fetchData();
    }
  }, [token, platform, setIsMessage]);

  useEffect(() => {
    if (patient) {
      setName(patient["pname"] + patient["fname"] + " " + patient["lname"]);
      setPid(patient["pid"]);
      setAge(moment().diff(patient["birthday"], "years"));
      setBirthday(
        moment(patient["birthday"]).add(543, "years").format("D MMMM YYYY"),
      );
      setPhoneNumber(patient["phone_number"]);
      setEmail(patient["email"]);
    } else {
      setName("");
      setPid("");
      setAge("");
      setBirthday("");
      setPhoneNumber("");
      setEmail("");
    }
  }, [patient]);

  // const getStyleStatus = (result) => {
  //   if (result === 'negative') {
  //     return {
  //       background: 'linear-gradient(222.3deg, #EFF198 0%, #E9DA52 180.56%)',
  //       color: '#575757'
  //     }
  //   } else if (result === 'positive') {
  //     return {
  //       background: 'linear-gradient(222.3deg, #F19898 0%, #9E1818 180.56%)',
  //       color: '#ffffff'
  //     }
  //   } else if (result === 'slow_acetylator') {
  //     return {
  //       background: 'linear-gradient(222.3deg, #F19898 0%, #9E1818 180.56%)',
  //       width: "300px",
  //       color: '#ffffff'
  //     }
  //   } else if (result === 'intermediate_acetylator') {
  //     return {
  //       background: 'linear-gradient(222.3deg, #FFBA9B 0%, #CB724A 180.56%)',
  //       width: "350px",
  //       color: '#ffffff'
  //     }
  //   } else if (result === 'rapid_acetylator') {
  //     return {
  //       background: 'linear-gradient(182.78deg, #ACF0FF 0%, #24A1B3 125.37%)',
  //       width: "300px",
  //       color: '#ffffff'
  //     }
  //   } else {
  //     return {}
  //   }
  // }
  const DisplayStylesButton = (testing_result_type) => {
    if (testing_result_type === "negative") {
      return "flex items-center justify-center bg-gradient-to-r from-[#E9DA52] to-[#EFF198] w-44 h-9 rounded-3xl #EFF198 text-[#575757]";
    } else if (testing_result_type === "positive") {
      return "flex items-center justify-center bg-gradient-to-r from-[#9E1818] to-[#F19898] w-44 h-9 rounded-3xl #F19898 text-[#FFFFFF]";
    } else if (testing_result_type === "slow_acetylator") {
      return "flex items-center justify-center bg-gradient-to-r from-[#9E1818] to-[#F19898] w-44 h-9 rounded-3xl #F19898 text-[#FFFFFF]";
    } else if (testing_result_type === "intermediate_acetylator") {
      return "flex items-center justify-center bg-gradient-to-r from-[#CB724A] to-[#FFBA9B] w-44 h-9 rounded-3xl #FFBA9B text-[#FFFFFF]";
    } else if (testing_result_type === "rapid_acetylator") {
      return "flex items-center justify-center bg-gradient-to-r from-[#24A1B3] to-[#ACF0FF] w-44 h-9 rounded-3xl #ACF0FF text-[#FFFFFF]";
    } else {
      return {};
    }
  };

  function urlify(text) {
    let urlRegex = /(https?:\/\/[^\s]+)/g;

    return text.replace(urlRegex, function (url) {
      let hyperlink = url;
      if (!hyperlink.match("^https?://")) {
        hyperlink = "http://" + hyperlink;
      }
      return (
        '<a className="text-[blue]" href="' +
        url +
        '" rel="noopener" noreferrer>' +
        url +
        "</a>"
      );
    });
  }

  return (
    <div style={{ paddingBottom: 100 }}>
      <HashLoader
        loading={loading}
        style={{ display: "flex", justifyContent: "center" }}
        color="#FF9768"
      />
      {/* <MenuDoctor menuActive={'searchDataPatient'} /> */}

      <div className={styles.content}>
        <div style={{ display: "flex", gridGap: 20, flexWrap: "wrap" }}>
          <Button
            onClick={() => {
              setToggle("gene");
            }}
            style={{
              width: 230,
              background: toggle === "gene" ? "" : "#FFFFFF",
            }}
          >
            ข้อมูลการตรวจยีน
          </Button>
          {/* <Button disabled={true} onClick={() => { setToggle('health') }} style={{ width: 230, background: toggle === 'health' ? '' : '#FFFFFF' }}>ข้อมูลสุขภาพ</Button>
          <Button disabled={true} onClick={() => { setToggle('note') }} style={{ width: 230, background: toggle === 'note' ? '' : '#FFFFFF' }}>Doctor Note</Button> */}
        </div>

        {/* <div className={`${styles.card} ${styles.informationCard}`}>
          <div className={styles.information}>
            <img src={require('../../asset/icon/profile-icon-orange.svg').default}></img>
            <div className={styles.key}>{name || '-'}</div>
          </div>
          <div className={styles.information}>
            <div className={styles.key}>เลขบัตรประชาชน</div>
            <div className={styles.value}>{pid || '-'}</div>
          </div>
          <div className={styles.information}>
            <div className={styles.key}>อายุ</div>
            <div className={styles.value}>{age || '-'}</div>
            <div className={styles.key}>ปี</div>
          </div>
          <div className={styles.information}>
            <div className={styles.key}>วันเกิด</div>
            <div className={styles.value}>{birthday || '-'}</div>
          </div>
          <div className={styles.information}>
            <div className={styles.key}>เบอร์โทร</div>
            <div className={styles.value}>{phoneNumber || '-'}</div>
          </div>
          <div className={styles.information}>
            <div className={styles.key}>อีเมล</div>
            <div className={styles.value}>{email || '-'}</div>
          </div>
        </div> */}

        {/* <div style={{ display: 'flex', gridGap: 20, flexWrap: 'wrap', marginTop: 20 }}>
          <Select
            style={{ width: 300 }}
            label={'ประเภทของยีน'}
            placeholder={'เลือกประเภทของยีน'}
            list={geneTypeList}
            value={geneType}
            setValue={setGeneType}
          />
          <Select
            style={{ width: 300 }}
            label={'ชื่อผลการตรวจ'}
            placeholder={'เลือกชื่อผลการตรวจ'}
            list={resultNameList}
            value={resultName}
            setValue={setResultName}
          />
        </div> */}

        {labList.filter((item) => {
          return item["expr2"].includes(resultName.current);
        }).length > 0 ? (
          <>
            {labList
              .filter((item) => {
                return item["expr2"].includes(resultName.current);
              })
              .map((item, index) => {
                return (
                  <div
                    key={index}
                    className={styles.card}
                    style={{ marginTop: 20 }}
                  >
                    <div className={styles.headContent}>
                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            fontWeight: 500,
                            fontSize: 20,
                            textDecorationLine: "underline",
                            color: "#526F65",
                          }}
                        >
                          {item["testing_group"]}
                        </div>
                        <div
                          style={{
                            fontWeight: 500,
                            fontSize: 20,
                            color: "#526F65",
                          }}
                        >
                          {item["customer_name"]}
                        </div>
                        <div
                          style={{
                            fontWeight: 500,
                            fontSize: 14,
                            color: "#A2B5BC",
                          }}
                        >
                          {moment(item["approve_date"])
                            .add(543, "years")
                            .format("D MMMM YYYY")}{" "}
                          เวลา {item["approve_time"]} น.
                        </div>
                      </div>
                      {/* <Button
                          onClick={() => { }}
                          style={getStyleStatus(item['lab_classify']['lab_result']['result']['result_key'])}
                          children={item['lab_classify']['lab_result']['result']['result_name']}
                        /> */}
                      <div
                        className={`font-medium ${DisplayStylesButton(item["lab_classify"]["lab_result"]["result"]["result_key"])}`}
                      >
                        {
                          item["lab_classify"]["lab_result"]["result"][
                            "result_name"
                          ]
                        }
                      </div>
                    </div>
                    <Line />
                    <div className={styles.bodyContent}>
                      <Detail keyName={"ชื่อการตรวจ"} value={item["expr2"]} />
                      <Detail
                        keyName={"วัตถุประสงค์"}
                        value={
                          item["lab_classify"]["lab_result"]["objective"] || "-"
                        }
                      />
                      <Detail
                        keyName={"หน่วยงานที่ส่งตรวจ"}
                        value={item["customer_name"]}
                      />
                      <Detail
                        keyName={"วันที่เก็บตัวอย่าง"}
                        value={moment(item["collect_date"])
                          .add(543, "years")
                          .format("D MMMM YYYY")}
                      />
                      <Detail
                        keyName={"วันที่ตรวจ"}
                        value={moment(item["report_date"])
                          .add(543, "years")
                          .format("D MMMM YYYY")}
                      />
                      <Detail
                        keyName={"ห้องปฏิบัติการ"}
                        value={item["testing_no"]}
                      />
                      <Detail
                        keyName={"หมายเลขผู้ป่วยนอก"}
                        value={item["hn"] || "-"}
                      />
                      <Detail
                        keyName={"ผลการวิเคราะห์"}
                        value={item["testing_result"]}
                      />
                      <Detail
                        keyName={"การแปลผล"}
                        value={
                          item["lab_classify"]["lab_result"]["result"][
                            "interpretation"
                          ] || "-"
                        }
                      />

                      <div
                        style={{
                          fontWeight: 500,
                          fontSize: 16,
                          color: "#2E2E2E",
                          marginTop: 20,
                        }}
                      >
                        ข้อมูลจากระบบ iLABplus หมายเลขตัวอย่าง{" "}
                        {item["testing_no"]} เลขที่รายงานผล {item["report_no"]}{" "}
                        วันที่ออกรายงานผล{" "}
                        {moment(item["report_date"])
                          .add(543, "years")
                          .format("D MMMM YYYY")}
                      </div>

                      {item["lab_classify"]["lab_result"]["result"][
                        "recommend_patient"
                      ].length > 0 ? (
                        <>
                          <div
                            style={{
                              color: "#2E2E2E",
                              fontSize: 20,
                              marginTop: 30,
                              fontWeight: 500,
                            }}
                          >
                            คำแนะนำ
                          </div>
                          <Line />

                          {item["lab_classify"]["lab_result"]["result"][
                            "recommend_patient"
                          ].map((recommend, index) => {
                            return (
                              <div className={styles.advice}>
                                <div>{index + 1}</div>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: urlify(recommend),
                                  }}
                                />
                              </div>
                            );
                          })}
                        </>
                      ) : null}
                    </div>
                  </div>
                );
              })}
          </>
        ) : (
          <NotfoundUi title={"ไม่พบข้อมูล"} />
        )}
      </div>
    </div>
  );
}

function Detail(props) {
  return (
    <div className={styles.resultDetail}>
      <div className={styles.key}>{props.keyName}</div>
      <div className={styles.value}>{props.value}</div>
    </div>
  );
}

function Line() {
  return <div className={styles.line}></div>;
}

export default GeneResultMicroservice;
